module.exports = __webpack_public_path__ + "img/mask-bottom.59f01a03.png";